import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import { AuthRoutingModule } from './auth/auth-routing.module';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './interceptors/auth.interceptor';
import { mockBackendInterceptor } from './interceptors/mock-backend.interceptor';

import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './services/title.strategy';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthRoutingModule,
    ComponentsModule
  ],
  providers: [
    provideHttpClient(withInterceptors([authInterceptor, mockBackendInterceptor])),
    { provide: TitleStrategy, useClass: AppTitleStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
